import styles from './promosLeftMenu.module.scss'
import React, {useMemo} from "react";
import './FlyerEditorLeftMenu.scss'
import {
    FlyerPageSpotDto,
    ItemsListMenuDto,
    PromoDto,
    PromoItemsDto,
    SelectPageForTabsDto, UserDto
} from "../../../../dtos";
import {useEffect, useRef, useState} from "react";
import {LeftMenuContent} from "./LeftMenuContent/LeftMenuContent";
import {ClickMenu} from "../../../../com/clickMenu/clickMenu";
import {ReactComponent as PlusIcon} from "../../../../assets/promos&items/icon_plus.svg";
// import Button from '@material-ui/core/Button';
import {MENU_LIST_PROMOTIONS_ITEMS} from "../../../../globals/Contants";
import {useDispatch} from "react-redux";
import {
    attachPromoToFlyer,
    // changeQualificationStatusForItems,
    changeSelectAllStatusForPromotionsAndItems,
    // changeStatusForShowOrHideAllItemsInAllPromotions,
    setItemsToPromosItemsState,
    setPromosToPromosItemsState
} from "../../../../store/actionCreators/promotionsItemsCreators";
import {useTypedSelector} from "../../../../hooks/useTypeSelector";
import {Box, Button, Checkbox, Grid, Typography} from "@mui/material";
import _ from "lodash";
import {makeStyles} from "@mui/styles";
import {changeQualificationStatusForFrame} from "../../../../store/actionCreators/spotsActionCreators";
import {getTotalPromotionsInFramesOnPage} from "../../../../globals/globFunctions";

const useStyles = makeStyles(() => ({
    unlinkSelectedPromosBtn: {
        '&.Mui-disabled': {
            opacity: `0.5`
        }
    },
    controlsPromoItemsButton: {
        display: `flex`,
        justifyContent: `center`,
        '& > .MuiButton-root': {
            textTransform: `inherit`,
            padding: `2px`,
            '& > .MuiTypography-root': {
                cursor: `pointer`,
                color: `#1D95DE`,
                lineHeight: `15px`,
                fontWeight: `bold`,
            },
            '&.Mui-disabled': {
                opacity: `0.5`
            }
        },
        '& > .MuiTypography-root': {
            // cursor: `pointer`,
            color: `#1D95DE`,
            lineHeight: `15px`,
            fontWeight: `bold`,
        },
    }
}))

interface Props {
    frames: FlyerPageSpotDto[];
    setFrames: (e: FlyerPageSpotDto[]) => void;
    setTargetPromos: (e: any) => void;
}

export const FlyerEditorLeftMenu = (props: Props) => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const promotionsItemsState = useTypedSelector((state) => state.promotionsAndItems);
    let flyerDetailsState = useTypedSelector((state) => state.flyerDetails);
    let selectedPageState = useTypedSelector<SelectPageForTabsDto>((state) => state.selectPageForTabs);
    // let flippingFlyerState = useTypedSelector((state) => state.flippingFlyer);

    let [totalPromotionsItems, setTotalPromotionsItems] = useState<string>('');
    // const [isOpenAllItems, setStatusForAllItems] = useState<boolean>(promotionsItemsState.isShowsAllItemsOfPromotions);
    // const [isApproveAll, changeApproveState] = useState<boolean>(false);
    const [isApproveSelected, changeApproveStateForSelectedPromos] = useState<boolean>(false);
    const [isClickOnApproveAllCheckbox, toggleApproveAllCheckboxStatue] = useState<boolean>(false);
    // const [statusForApproveAll, setStatusForApproveAll] = useState<string>('default');
    const anchorRef = useRef(null);
    const [open, setOpen] = useState(false);
    // const [isSelectAll, toggleSelectAll] = useState<boolean>(promotionsItemsState.isSelectAllMode);
    const [allPromosWithItems, setAllPromosWithItems] = useState<PromoDto[]>([]);
    const [selectedPromos, setSelectedPromos] = useState<PromoDto[]>([]);
    const [selectedFrames, setSelectedFrames] = useState<FlyerPageSpotDto[]>([]);
    const [expandedPromos, setExpandedPromos] = useState<PromoDto[]>([]);
    const [isSelectedPromosExpanded, toggleExpandStatus] = useState<boolean>(true);
    const [isAllSelectedPromosDoesntHaveItems, toggleStatusForAllSelectedPromosWhichDoesntHaveItems] = useState<boolean>(true);
    const totalPromotionsInFrames = useMemo(() => {
        return getTotalPromotionsInFramesOnPage(props.frames);
    }, [props.frames]);
    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };
    const prevOpen = useRef(open);
    let userDtoStr = localStorage.getItem('userDto');
    let isUserViewer = true;
    let isUserEditor = false;
    if(userDtoStr){
        let userDto: UserDto = JSON.parse(userDtoStr);
        isUserViewer = userDto.role !== 2 && userDto.role !== 3;
        isUserEditor = userDto.role === 2;
    }

    // useEffect(() => {
    //     dispatch(changeStatusForShowOrHideAllItemsInAllPromotions(isOpenAllItems));
    // }, [isOpenAllItems]);

    useEffect(() => {
        if (promotionsItemsState.type === 'CHANGE_QUALIFICATION_LVL_FOR_ITEMS_SUCCESS') {
            //for items in selected promos for all frames (1, 2)
            const items: PromoItemsDto[] = [];
            console.log(promotionsItemsState.itemsIdsForChangeQualificationLVL.length);
            promotionsItemsState.pages[selectedPageState.pageNo !== 0 ? selectedPageState.pageNo - 1 : selectedPageState.pageNo].items.forEach((item: PromoItemsDto) => {
                const promoItem = {...item};
                if (!isClickOnApproveAllCheckbox && promotionsItemsState.itemsIdsForChangeQualificationLVL.length === 1) {
                    const isTargetItemData = promotionsItemsState.itemsIdsForChangeQualificationLVL.some((targetIDValue: number) => targetIDValue === item.fpiRecId);
                    if (isTargetItemData) {
                        if (promoItem.qualificationLevel === 1) {
                            promoItem.qualificationLevel = 2;
                        } else if (promoItem.qualificationLevel === 2) {
                            promoItem.qualificationLevel = 1;
                        }
                    }
                } else {
                    if (selectedPromos.length) {
                        let allItemsArraysInSelectedPromos = selectedPromos.map((promo: PromoDto) => {
                            if (promo.flyerPromoItems?.length) {
                                return promo.flyerPromoItems;
                            }
                        });
                        let allItemsInSelectedPromos: PromoItemsDto[] = [];
                        allItemsArraysInSelectedPromos.forEach((itemsArray: any) => {
                            if (itemsArray) {
                                allItemsInSelectedPromos = [...allItemsInSelectedPromos, ...itemsArray];
                            }
                        })
                        if (allItemsInSelectedPromos.length) {
                            const selectedItemIsExistInSelectedPromoAndAllItemsInFrames = allItemsInSelectedPromos.some((item: PromoItemsDto) => item.fpiRecId === promoItem.fpiRecId);
                            if (isApproveSelected && selectedItemIsExistInSelectedPromoAndAllItemsInFrames && promoItem.qualificationLevel === 1) {
                                promoItem.qualificationLevel = 2;
                            } else if (!isApproveSelected && selectedItemIsExistInSelectedPromoAndAllItemsInFrames && promoItem.qualificationLevel === 2) {
                                promoItem.qualificationLevel = 1;
                            }
                        }
                    }
                }
                items.push(promoItem);
            })
            toggleApproveAllCheckboxStatue(false);
            dispatch(setItemsToPromosItemsState(items, selectedPageState.pageNo));
        } else if (promotionsItemsState.type === 'CHANGE_QUALIFICATION_LVL_FOR_PROMOS_SUCCESS') {
            //for selected promos in frames (1, 2)
            const promos: PromoDto[] = [];
            promotionsItemsState.pages[selectedPageState.pageNo !== 0 ? selectedPageState.pageNo - 1 : selectedPageState.pageNo].promos.forEach((promo: PromoDto) => {
                const targetPromo = {...promo};
                const selectedPromoIsExistInAllPromosInFrame = selectedPromos.some((selectedPromo: PromoDto) => selectedPromo.flrRecId === targetPromo.flrRecId);
                if (isClickOnApproveAllCheckbox) {
                    if (isApproveSelected && selectedPromoIsExistInAllPromosInFrame && targetPromo.qualificationLevel === 1) {
                        targetPromo.qualificationLevel = 2
                    } else if (!isApproveSelected && selectedPromoIsExistInAllPromosInFrame && targetPromo.qualificationLevel === 2) {
                        targetPromo.qualificationLevel = 1
                    }
                } else {
                    if (selectedPromoIsExistInAllPromosInFrame && targetPromo.qualificationLevel === 1) {
                        targetPromo.qualificationLevel = 2
                    } else if (selectedPromoIsExistInAllPromosInFrame && targetPromo.qualificationLevel === 2) {
                        targetPromo.qualificationLevel = 1
                    }
                }
                promos.push(targetPromo);
            })
            toggleApproveAllCheckboxStatue(false);
            dispatch(setPromosToPromosItemsState(promos, selectedPageState.pageNo));
        }

    }, [promotionsItemsState.type])

    useEffect(() => {
        let totalPromotions: number = 0;
        let totalItems: number = 0;
        let totalPromotionsWithItems: PromoDto[] = [];
        props.frames.forEach((frame: FlyerPageSpotDto) => {
            if (frame.flyerPromos?.length) {
                totalPromotions += frame.flyerPromos?.length;
                frame.flyerPromos?.forEach((promo: PromoDto) => {
                    if (promo.flyerPromoItems?.length) {
                        totalItems += promo.flyerPromoItems?.length;
                        totalPromotionsWithItems.push(promo);
                    }
                })
            }
        })
        setTotalPromotionsItems(`Total: ${totalPromotions} & ${totalItems}`);
        // toggleSelectAll(false);
        // setSelectedPromos([]);
        selectAllPossiblePromosInFramesOrDeselectAll(promotionsItemsState.isSelectAllMode);
        setAllPromosWithItems(totalPromotionsWithItems);
        // const newStateForExpandedPromos = expandedPromos.filter((expandedPromo: PromoDto) => {
        //     const isExpandedPromoHasItems = totalPromotionsWithItems.find((promoWithItems: PromoDto) => {
        //         if (promoWithItems.flrRecId === expandedPromo.flrRecId) {
        //             return promoWithItems;
        //         }
        //     });
        //     if (isExpandedPromoHasItems) {
        //         return expandedPromo;
        //     }
        // });
        // setExpandedPromos(newStateForExpandedPromos);
    }, [props.frames]);


    useEffect(() => {
        // const totalPromotionsInFrames: PromoDto[] = [];
        // if (props.frames.length) {
        //     [...props.frames].forEach((frame: FlyerPageSpotDto) => {
        //         let promosFromFrame: PromoDto = frame.flyerPromos![frame.flyerPromos!.length - 1 < 0 ? 0 : frame.flyerPromos!.length - 1];
        //         if (promosFromFrame) {
        //             totalPromotionsInFrames.push({
        //                 ...promosFromFrame
        //             });
        //         }
        //     });
        //
        //     if (totalPromotionsInFrames.length !== 0 && totalPromotionsInFrames.length === selectedPromos.length) {
        //         toggleSelectAll(true);
        //     } else {
        //         toggleSelectAll(false);
        //     }
        // }
        if (selectedPromos.length) {
            const expandedPromosInSelectedPromos = selectedPromos.filter((selectedPromo: PromoDto) => {
                const isAlreadyExpanded = expandedPromos.find((expandedPromo: PromoDto) => expandedPromo.flrRecId === selectedPromo.flrRecId);
                if (isAlreadyExpanded) {
                    return selectedPromo;
                }
            })
            const selectedPromosWithItems = selectedPromos.filter((selectedPromo: PromoDto) => {
                if (selectedPromo.flyerPromoItems?.length) {
                    return selectedPromo;
                }
            });
            toggleExpandStatus(!(expandedPromosInSelectedPromos.length !== 0 &&
                expandedPromosInSelectedPromos.length === selectedPromosWithItems.length
            ));
        }
        // if(!promotionsItemsState.isSelectAllMode){
        //     toggleExpandStatus(true);
        // }
        const isAllSelectedPromosDoesntHaveItems = selectedPromos.every((selectedPromo: PromoDto) => selectedPromo.flyerPromoItems?.length === 0);
        toggleStatusForAllSelectedPromosWhichDoesntHaveItems(isAllSelectedPromosDoesntHaveItems);
        changeApproveStateForSelectedPromos(false);
    }, [selectedPromos]);

    useEffect(() => {
        if(props.frames?.length > 0){
            dispatch(changeSelectAllStatusForPromotionsAndItems(props.frames?.length === selectedFrames.length))
        }

    }, [selectedFrames]);

    const clickMenuData: ItemsListMenuDto = {
        setOpen: setOpen,
        prevOpen: prevOpen,
        open: open,
        anchorRef: anchorRef,
        menuList: MENU_LIST_PROMOTIONS_ITEMS
    }


    const selectAllPossiblePromosInFramesOrDeselectAll = (isSelectAll: boolean) => {
        if (props.frames?.length) {
            if (isSelectAll) {
                setSelectedPromos(totalPromotionsInFrames);
                setSelectedFrames(props.frames);
                if(!isSelectedPromosExpanded){
                    setExpandedPromos(totalPromotionsInFrames);
                }
            } else {
                if (props.frames?.length === selectedFrames.length) {
                    setSelectedPromos([]);
                    setSelectedFrames([]);
                }
            }
        } else {
            setSelectedPromos([]);
            setSelectedFrames([]);
        }

    }

    const showAllItemsOnSelectedPromotions = (e: React.MouseEvent<HTMLElement>) => {
        if(isSelectedPromosExpanded){
            setExpandedPromos([...expandedPromos, ...selectedPromos]);
            toggleExpandStatus(false);
        } else {
            setExpandedPromos([]);
            toggleExpandStatus(true);
        }
        // const expandedPromosInSelectedPromos = selectedPromos.filter((selectedPromo: PromoDto) => {
        //     const isAlreadyExpanded = expandedPromos.find((expandedPromo: PromoDto) => expandedPromo.flrRecId === selectedPromo.flrRecId);
        //     if (isAlreadyExpanded && selectedPromo.flyerPromoItems?.length) {
        //         return selectedPromo;
        //     }
        // });
        // const selectedPromosWithItems = selectedPromos.filter((selectedPromo: PromoDto) => {
        //     if (selectedPromo.flyerPromoItems?.length) {
        //         return selectedPromo;
        //     }
        // });
        // if (expandedPromosInSelectedPromos && expandedPromosInSelectedPromos.length === selectedPromosWithItems.length) {
        //     const newExpandedPromosState = expandedPromos.filter((expandedPromo: PromoDto) => {
        //         const isSelectedPromoAlreadyExpanded = selectedPromos.find((selectedPromo: PromoDto) => selectedPromo.flrRecId === expandedPromo.flrRecId);
        //         if (!isSelectedPromoAlreadyExpanded) {
        //             return expandedPromo;
        //         }
        //     })
        //     setExpandedPromos(newExpandedPromosState);
        // } else {
        //     setExpandedPromos([...expandedPromos, ...selectedPromosWithItems]);
        // }
        // if(allPromosWithItems.length <= expandedPromos.length){
        //     setExpandedPromos([]);
        // } else {
        //     setExpandedPromos(allPromosWithItems);
        // }
        // setStatusForAllItems(!isOpenAllItems);
    }

    // const onChangeApproveAll = (e: React.ChangeEvent<HTMLInputElement>) => {
    //     const isChecked = e.target.checked;
    //     changeApproveState(isChecked);
    //     let promosQualification: number[] = [];
    //     let itemsQualification: number[] = [];
    //
    //     if (isChecked) {
    //         promotionsItemsState.pages[selectedPageState.pageNo !== 0 ? selectedPageState.pageNo - 1 : selectedPageState.pageNo].items.forEach((item: PromoItemsDto) => {
    //             if (item.qualificationLevel === 1) {
    //                 itemsQualification.push(item.fpiRecId!);
    //             }
    //         })
    //         promotionsItemsState.pages[selectedPageState.pageNo !== 0 ? selectedPageState.pageNo - 1 : selectedPageState.pageNo].promos.forEach((promo: PromoDto) => {
    //             if (promo.qualificationLevel === 1) {
    //                 promosQualification.push(promo.flrRecId!);
    //             }
    //         })
    //     } else {
    //         promotionsItemsState.pages[selectedPageState.pageNo !== 0 ? selectedPageState.pageNo - 1 : selectedPageState.pageNo].items.forEach((item: PromoItemsDto) => {
    //             if (item.qualificationLevel === 2) {
    //                 itemsQualification.push(item.fpiRecId!);
    //             }
    //         })
    //         promotionsItemsState.pages[selectedPageState.pageNo !== 0 ? selectedPageState.pageNo - 1 : selectedPageState.pageNo].promos.forEach((promo: PromoDto) => {
    //             if (promo.qualificationLevel === 2) {
    //                 promosQualification.push(promo.flrRecId!);
    //             }
    //         })
    //     }
    //
    //     if (itemsQualification.length !== 0) {
    //         dispatch(changeQualificationStatusForItems(itemsQualification, flyerDetailsState?.flyLacRec?.lacCode!, isChecked ? 2 : 1))
    //     }
    //     if (promosQualification.length !== 0) {
    //         dispatch(changeQualificationStatusForPromos(promosQualification, flyerDetailsState?.flyLacRec?.lacCode!, isChecked ? 2 : 1));
    //     }
    // }

    const onChangeApproveSelected = (e: React.ChangeEvent<HTMLInputElement>) => {
        const isChecked = e.target.checked;
        toggleApproveAllCheckboxStatue(true);
        changeApproveStateForSelectedPromos(isChecked);
        let promosQualification: number[] = [];
        // let itemsQualification: number[] = [];
        if (isChecked) {
            promotionsItemsState.pages[selectedPageState.pageNo !== 0 ? selectedPageState.pageNo - 1 : selectedPageState.pageNo].items.forEach((item: PromoItemsDto) => {
                if (selectedPromos.length) {
                    let allItemsArraysInSelectedPromos = selectedPromos.map((promo: PromoDto) => {
                        if (promo.flyerPromoItems?.length) {
                            return promo.flyerPromoItems;
                        }
                    });
                    let allItemsInSelectedPromos: PromoItemsDto[] = [];
                    if (allItemsArraysInSelectedPromos) {
                        allItemsArraysInSelectedPromos.forEach((itemsArray: any) => {
                            if (itemsArray) {
                                allItemsInSelectedPromos = [...allItemsInSelectedPromos, ...itemsArray];
                            }
                        })
                        if (allItemsInSelectedPromos.length) {
                            const selectedItemIsExistInSelectedPromoAndAllItemsInFrames = allItemsInSelectedPromos.some((itemPromo: PromoItemsDto) => item.fpiRecId === itemPromo.fpiRecId);
                            if (selectedItemIsExistInSelectedPromoAndAllItemsInFrames && item.qualificationLevel === 1) {
                                // itemsQualification.push(item.fpiRecId!);
                            }
                        }
                    }
                }
            })
            promotionsItemsState.pages[selectedPageState.pageNo !== 0 ? selectedPageState.pageNo - 1 : selectedPageState.pageNo].promos.forEach((promo: PromoDto) => {
                const selectedPromoIsExistInAllPromosInFrame = selectedPromos.some((selectedPromo: PromoDto) => selectedPromo.flrRecId === promo.flrRecId);
                console.log(`look here`);
                if (selectedPromoIsExistInAllPromosInFrame && promo.qualificationLevel === 1) {
                    promosQualification.push(promo.flrRecId!);
                }
            })
        } else {
            promotionsItemsState.pages[selectedPageState.pageNo !== 0 ? selectedPageState.pageNo - 1 : selectedPageState.pageNo].items.forEach((item: PromoItemsDto) => {
                if (selectedPromos.length) {
                    let allItemsArraysInSelectedPromos = selectedPromos.map((promo: PromoDto) => {
                        if (promo.flyerPromoItems?.length) {
                            return promo.flyerPromoItems;
                        }
                    });
                    let allItemsInSelectedPromos: PromoItemsDto[] = [];
                    allItemsArraysInSelectedPromos.forEach((itemsArray: any) => {
                        if (itemsArray) {
                            allItemsInSelectedPromos = [...allItemsInSelectedPromos, ...itemsArray];
                        }
                    })
                    if (allItemsInSelectedPromos.length) {
                        const selectedItemIsExistInSelectedPromoAndAllItemsInFrames = allItemsInSelectedPromos.some((itemPromo: PromoItemsDto) => item.fpiRecId === itemPromo.fpiRecId);
                        if (selectedItemIsExistInSelectedPromoAndAllItemsInFrames && item.qualificationLevel === 2) {
                            // itemsQualification.push(item.fpiRecId!);
                        }
                    }
                }
            })
            promotionsItemsState.pages[selectedPageState.pageNo !== 0 ? selectedPageState.pageNo - 1 : selectedPageState.pageNo].promos.forEach((promo: PromoDto) => {
                const selectedPromoIsExistInAllPromosInFrame = selectedPromos.some((selectedPromo: PromoDto) => selectedPromo.flrRecId === promo.flrRecId);
                if (selectedPromoIsExistInAllPromosInFrame && promo.qualificationLevel === 2) {
                    promosQualification.push(promo.flrRecId!);
                }
            })
        }
        // if (itemsQualification.length !== 0) {
        //     dispatch(changeQualificationStatusForItems(itemsQualification, flyerDetailsState?.flyLacRec?.lacCode!, isChecked ? 2 : 1, false, flyerDetailsState, selectedPageState.pageNo !== 0 ? selectedPageState.pageNo - 1 : selectedPageState.pageNo))
        // }
        let framesIds = selectedFrames.map((selectedFrame: FlyerPageSpotDto) => {
            return selectedFrame.fpsRecId!
        });
        if(framesIds.length){
            dispatch(changeQualificationStatusForFrame(
                framesIds,
                flyerDetailsState?.flyLacRec?.lacCode!,
                isChecked ? 2 : 1,
                flyerDetailsState,
                selectedPageState.pageNo !== 0 ? selectedPageState.pageNo - 1 : selectedPageState.pageNo,
                []
            ));
        }
        // if (promosQualification.length !== 0) {
        //     dispatch(changeQualificationStatusForPromos(promosQualification, flyerDetailsState?.flyLacRec?.lacCode!, isChecked ? 2 : 1, flyerDetailsState, false, selectedPageState.pageNo !== 0 ? selectedPageState.pageNo - 1 : selectedPageState.pageNo));
        // }
    }

    // const approveSelectedPromosAndItems = () => {
    //     let promosQualification: number[] = [];
    //     let itemsQualification: number[] = [];
    //
    //     selectedPromos.forEach((selectedPromo: PromoDto) => {
    //         if (selectedPromo.qualificationLevel === 1) {
    //             promosQualification.push(selectedPromo.flrRecId!);
    //         }
    //         if (selectedPromo.flyerPromoItems?.length) {
    //             selectedPromo.flyerPromoItems.forEach((itemFromSelectedPromo: PromoItemsDto) => {
    //                 if (itemFromSelectedPromo.qualificationLevel === 1) {
    //                     itemsQualification.push(itemFromSelectedPromo.fpiRecId!);
    //                 }
    //             })
    //         }
    //     })
    //     if (itemsQualification.length !== 0) {
    //         dispatch(changeQualificationStatusForItems(itemsQualification, flyerDetailsState?.flyLacRec?.lacCode!, 2, false, flyerDetailsState, selectedPageState.pageNo !== 0 ? selectedPageState.pageNo - 1 : selectedPageState.pageNo))
    //     }
    //     if (promosQualification.length !== 0) {
    //         dispatch(changeQualificationStatusForPromos(promosQualification, flyerDetailsState?.flyLacRec?.lacCode!, 2, false, flyerDetailsState, selectedPageState.pageNo !== 0 ? selectedPageState.pageNo - 1 : selectedPageState.pageNo));
    //     }
    // }

    const handleChangeSelectAll = (e: React.ChangeEvent<HTMLInputElement>) => {
        // toggleSelectAllChecker(!isSelectAllChecker);
        selectAllPossiblePromosInFramesOrDeselectAll(e.target.checked);
        // toggleSelectAll(!isSelectAll);
    }

    const onSelectFrame = (event: React.MouseEvent<HTMLElement>, promo: PromoDto, index: number, upcomingFrame: FlyerPageSpotDto) => {
        let promotionsInFrames: PromoDto[] = [];
        let frames: FlyerPageSpotDto[] = [];
        [...props.frames].forEach((frame: FlyerPageSpotDto) => {
            if(promo){
                let promosFromFrame: PromoDto = frame.flyerPromos![frame.flyerPromos!.length - 1 < 0 ? 0 : frame.flyerPromos!.length - 1];
                if (promosFromFrame) {
                    const isLastSelectedPromo = selectedPromos.find((selectedPromo: PromoDto) => selectedPromo.flrRecId === promosFromFrame.flrRecId);
                    const isLastSelected = isLastSelectedPromo && isLastSelectedPromo.isLastSelected ? isLastSelectedPromo.isLastSelected : false;
                    promotionsInFrames.push({
                        ...promosFromFrame,
                        isLastSelected: isLastSelected
                    });
                } else {
                    promotionsInFrames.push({});
                }
            }
            const isLastSelectedFrame = selectedFrames.find((selectedFrame: FlyerPageSpotDto) => selectedFrame.fpsRecId === frame.fpsRecId);
            const isLastSelected = isLastSelectedFrame && isLastSelectedFrame.isLastSelected ? isLastSelectedFrame.isLastSelected : false;
            frames.push({
                ...frame,
                isLastSelected: isLastSelected
            });
        });
        if (event.ctrlKey || event.metaKey) {
            if(promo){
                const isPromotionAlreadySelected = selectedPromos.some((selectedPromo: PromoDto) => selectedPromo.flrRecId === promo.flrRecId);
                if (isPromotionAlreadySelected) {
                    const newStateForSelectedPromos = selectedPromos.filter((selectedPromo: PromoDto) => selectedPromo.flrRecId !== promo.flrRecId);
                    if (newStateForSelectedPromos.length) {
                        newStateForSelectedPromos[0].isLastSelected = true;
                    }
                    setSelectedPromos(newStateForSelectedPromos);
                } else {
                    setSelectedPromos([...selectedPromos, promo])
                }
            }
            const isFrameAlreadySelected = selectedFrames.some((selectedFrame: FlyerPageSpotDto) => selectedFrame.fpsRecId === upcomingFrame.fpsRecId);
            if (isFrameAlreadySelected) {
                const newStateForSelectedFrames = selectedFrames.filter((selectedFrame: FlyerPageSpotDto) => selectedFrame.fpsRecId !== upcomingFrame.fpsRecId);
                if (newStateForSelectedFrames.length) {
                    newStateForSelectedFrames[0].isLastSelected = true;
                }
                setSelectedFrames(newStateForSelectedFrames);
            } else {
                setSelectedFrames([...selectedFrames, upcomingFrame])
            }
        } else if (event.shiftKey) {
            if(promo){
                const isLastSelectedPromoExist = promotionsInFrames.some((selectedPromo: PromoDto) => selectedPromo.isLastSelected);
                if (isLastSelectedPromoExist) {
                    let lastSelectedIndex: number = 0;
                    promotionsInFrames.forEach((selectedPromo: PromoDto, index: number) => {
                        if (selectedPromo.isLastSelected) {
                            lastSelectedIndex = index;
                            return selectedPromo;
                        }
                    });
                    const isSelectedItemIndexMoreThanLastSelectedIndex = index > lastSelectedIndex;
                    if (isSelectedItemIndexMoreThanLastSelectedIndex) {
                        const newStateForSelectedPromos = [...promotionsInFrames].filter((promotion: PromoDto, promoIndex: number) => {
                            if (promoIndex >= lastSelectedIndex && promoIndex <= index && !_.isEmpty(promotion)) {
                                return promotion;
                            }
                        });
                        setSelectedPromos(newStateForSelectedPromos);
                    } else {
                        const newStateForSelectedPromos = [...promotionsInFrames].filter((promotion: PromoItemsDto, promoIndex: number) => {
                            if (promoIndex >= index && promoIndex <= lastSelectedIndex && !_.isEmpty(promotion)) {
                                // if (promoIndex === lastSelectedIndex) {
                                //     promotion.isLastSelected = true;
                                // }
                                return promotion;
                            }
                        })
                        setSelectedPromos(newStateForSelectedPromos);
                    }
                } else {
                    setSelectedPromos([{
                        ...promo,
                        isLastSelected: true
                    }]);
                }
            }
            const isLastSelectedFrameExist = frames.some((frame: FlyerPageSpotDto) => frame.isLastSelected);
            if (isLastSelectedFrameExist) {
                let lastSelectedIndex: number = 0;
                frames.forEach((frame: FlyerPageSpotDto, index: number) => {
                    if (frame.isLastSelected) {
                        lastSelectedIndex = index;
                        return frame;
                    }
                });
                const isSelectedItemIndexMoreThanLastSelectedIndex = index > lastSelectedIndex;
                if (isSelectedItemIndexMoreThanLastSelectedIndex) {
                    const newStateForSelectedFrames = [...frames].filter((frame: FlyerPageSpotDto, frameIndex: number) => {
                        if (frameIndex >= lastSelectedIndex && frameIndex <= index) {
                            return frame;
                        }
                    });
                    setSelectedFrames(newStateForSelectedFrames);
                } else {
                    const newStateForSelectedFrames = [...frames].filter((frame: FlyerPageSpotDto, frameIndex: number) => {
                        if (frameIndex >= index && frameIndex <= lastSelectedIndex) {
                            // if (promoIndex === lastSelectedIndex) {
                            //     promotion.isLastSelected = true;
                            // }
                            return frame;
                        }
                    })
                    setSelectedFrames(newStateForSelectedFrames);
                }
            } else {
                if(promo){
                    setSelectedPromos([{
                        ...promo,
                        isLastSelected: true
                    }]);
                }
                setSelectedFrames([{
                    ...upcomingFrame,
                    isLastSelected: true
                }]);
            }
        } else {
            // const isPromotionAlreadySelected = selectedPromos.some((selectedPromo: PromoDto) => selectedPromo.flrRecId === promo.flrRecId);
            // if(isPromotionAlreadySelected){
            //     setSelectedPromos([]);
            // } else {
            if(promo){
                setSelectedPromos([{
                    ...promo,
                    isLastSelected: true
                }]);
            }
            setSelectedFrames([{
                ...upcomingFrame,
                isLastSelected: true
            }]);
            // }
        }
    }

    const makeUnlinkSelectedPromos = () => {
        let targetPromos: PromoDto[] = [...selectedPromos];
        let targetPromosIds = targetPromos.map((promo: PromoDto) => promo.flrRecId!);
        props.setTargetPromos(targetPromos);
        dispatch(
            attachPromoToFlyer(
                flyerDetailsState.flyRecId,
                targetPromosIds,
                false,
                flyerDetailsState.flyLacRec.lacCode
            )
        );
    };


    return (
        <div className={`${styles.flyers_promos_editor_left_menu}`}>
            <div className={`${styles.row}`}>
                <div className={`${styles.current_promos}`}>
                    <div className={styles.promos_items_name}>
                        PROMOTIONS & ITEMS
                    </div>

                    <Button
                        ref={anchorRef}
                        aria-controls={open ? 'menu-list-grow' : undefined}
                        aria-haspopup="true"
                        onClick={handleToggle}
                        disabled={isUserViewer}
                        sx={{
                            ':disabled': {
                                opacity: "0.3"
                            }
                        }}
                    >
                        <PlusIcon/>
                    </Button>
                    <ClickMenu list={clickMenuData}/>
                </div>
                <Box sx={{
                    display: `flex`,
                    alignItems: `center`,
                    // backgroundColor: `white`,
                    padding: `2px 5px`,
                }}>
                    <Typography className={`${styles.total_promos}`}>
                        {totalPromotionsItems}
                    </Typography>
                </Box>
            </div>
            <Box sx={{mb: `5px`}}>
                <Grid container alignItems={`center`} justifyContent={`center`} columns={16}>
                    <Grid item xs={5}>
                        <Box sx={{
                            display: `flex`,
                            alignItems: `center`,
                            // backgroundColor: `white`,
                            padding: `2px 5px`,
                            justifyContent: `flex-start`
                        }}
                             className={classes.controlsPromoItemsButton}
                        >
                            <Checkbox
                                checked={props.frames?.length !== 0 && props.frames?.length === selectedFrames.length}
                                disabled={flyerDetailsState.flyFstRec.fstCaption === "Published" || props.frames.length === 0}
                                onChange={handleChangeSelectAll}
                                // checkedIcon={<CheckedIcon />}
                                inputProps={{'aria-label': 'controlled'}}
                                sx={{
                                    padding: `0`,
                                    marginRight: `5px`,

                                    // backgroundColor: `white`
                                }}
                            />
                            <Typography sx={{
                                // marginRight: `5px`,
                                lineHeight: `15px`,
                                color: `black!important`,
                                opacity: flyerDetailsState.flyFstRec.fstCaption === "Published" || props.frames.length === 0 ? `0.5` : `1`
                            }}>
                                Select all
                            </Typography>
                            {/*<Button*/}
                            {/*    className={classes.unlinkSelectedPromosBtn}*/}
                            {/*    disabled={selectedPromos.length === 0}*/}
                            {/*    sx={{*/}
                            {/*        marginLeft: `5px`*/}
                            {/*    }}*/}
                            {/*    onClick={makeUnlinkSelectedPromos}>*/}
                            {/*    <UnlinkIcon/>*/}
                            {/*</Button>*/}
                        </Box>
                    </Grid>
                    <Grid item xs={3}>
                        <Box className={classes.controlsPromoItemsButton}>
                            <Button disabled={selectedPromos.length === 0 || flyerDetailsState.flyFstRec.fstCaption === "Published" || isUserViewer} onClick={makeUnlinkSelectedPromos}>
                                <Typography>
                                    Unlink
                                </Typography>
                            </Button>
                        </Box>
                    </Grid>
                    <Grid item xs={3}>
                        <Box className={classes.controlsPromoItemsButton}>
                            <Button onClick={showAllItemsOnSelectedPromotions}
                                    disabled={selectedPromos.length === 0 || isAllSelectedPromosDoesntHaveItems}>
                                <Typography>{isSelectedPromosExpanded ? 'Expand' : 'Collapse'}</Typography>
                            </Button>
                        </Box>
                    </Grid>
                    <Grid item xs>
                        {
                            promotionsItemsState.isQualified &&
                            <Box
                                className={classes.controlsPromoItemsButton}
                                // className={`${styles.approve_all_wrapper} ${!promotionsItemsState.isQualified ? styles.disabled : ''}`}
                            >
                                {/*<Button disabled={selectedPromos.length === 0} onClick={approveSelectedPromosAndItems}>*/}
                                {/*    <Typography>Approve</Typography>*/}
                                {/*</Button>*/}
                                <Box sx={{
                                    display: `flex`,
                                    alignItems: `center`,
                                    // backgroundColor: `white`,
                                    padding: `2px 5px`,
                                    justifyContent: `flex-start`
                                }}
                                     className={classes.controlsPromoItemsButton}
                                >
                                    <Checkbox
                                        checked={isApproveSelected}
                                        onChange={onChangeApproveSelected}
                                        // checkedIcon={<CheckedIcon />}
                                        disabled={(selectedPromos.length === 0 && selectedFrames.length === 0) || flyerDetailsState.flyFstRec.fstCaption === "Published" || isUserViewer || isUserEditor}
                                        inputProps={{'aria-label': 'controlled'}}
                                        sx={{
                                            padding: `0`,
                                            marginRight: `5px`,
                                            // backgroundColor: `white`
                                        }}
                                    />
                                    <Typography sx={{
                                        // marginRight: `5px`,
                                        lineHeight: `15px`,
                                        color: `black!important`,
                                        opacity: (selectedPromos.length === 0 && selectedFrames.length === 0) || flyerDetailsState.flyFstRec.fstCaption === "Published" || isUserViewer || isUserEditor ? `0.5`: `1`
                                    }}>
                                        Approve
                                    </Typography>
                                    {/*<Button*/}
                                    {/*    className={classes.unlinkSelectedPromosBtn}*/}
                                    {/*    disabled={selectedPromos.length === 0}*/}
                                    {/*    sx={{*/}
                                    {/*        marginLeft: `5px`*/}
                                    {/*    }}*/}
                                    {/*    onClick={makeUnlinkSelectedPromos}>*/}
                                    {/*    <UnlinkIcon/>*/}
                                    {/*</Button>*/}
                                </Box>

                                {/*<div className={styles.input_wrapper}>*/}
                                {/*    <input type="checkbox" id="approve_all_promos" disabled={!promotionsItemsState.isQualified}*/}
                                {/*           onChange={onChangeApproveAll} checked={isApproveAll}/>*/}
                                {/*    <label htmlFor="approve_all_promos">*/}

                                {/*    </label>*/}
                                {/*</div>*/}
                            </Box>
                        }
                    </Grid>
                </Grid>
            </Box>
            <LeftMenuContent
                frames={props.frames}
                setFrames={props.setFrames}
                setTargetPromos={props.setTargetPromos}
                isSelectAll={promotionsItemsState.isSelectAllMode}
                onSelectFrame={onSelectFrame}
                selectedFrames={selectedFrames}
                selectedPromos={selectedPromos}
                setExpandedPromos={setExpandedPromos}
                expandedPromos={expandedPromos}
            />
        </div>
    )
}